import axios from "axios";
import { TallyConfig } from "../helpers/constants";
// import { ipcRenderer } from "electron";

export async function TestConnection() {

    try{
        let resp = await window.electron.tallyConnect({
            url: `${TallyConfig.host}:${TallyConfig.port}`,
            method: 'POST',
            headers: {
                'Content-Type': 'application/xml',
            },
            timeout: 5000,
            data: '<ENVELOPE>\r\n    <HEADER>\r\n        <VERSION>1</VERSION>\r\n        <TALLYREQUEST>Export</TALLYREQUEST>\r\n        <TYPE>Collection</TYPE>\r\n        <ID>CostCenters</ID>\r\n    </HEADER>\r\n    <BODY>\r\n        <DESC>\r\n            <STATICVARIABLES>\r\n                <SVEXPORTFORMAT>SysName:XML</SVEXPORTFORMAT>\r\n            </STATICVARIABLES>\r\n            <TDL>\r\n                <TDLMESSAGE>\r\n                    <COLLECTION ISMODIFY="No" ISFIXED="No" ISINITIALIZE="No" ISOPTION="No" ISINTERNAL="No" NAME="CostCenters">\r\n                        <TYPE>CostCenter</TYPE>\r\n                        <NATIVEMETHOD>*</NATIVEMETHOD>                        \r\n                        <FILTERS>filter</FILTERS>\r\n                    </COLLECTION>\r\n                    <SYSTEM TYPE="Formulae" NAME="filter">ISEMPLOYEEGROUP="NO"</SYSTEM>\r\n                </TDLMESSAGE>\r\n            </TDL>\r\n        </DESC>\r\n    </BODY>        \r\n</ENVELOPE>'
        
        })
        if(resp.status === 200){
            return resp.data
        }else{
            return false
        }
    }catch(err){
        console.log(err)
        return false
    }

    
}